import { PulseEnvironment } from '../../globals';

export class Quote {
    constructor(private env: PulseEnvironment) {}

    async quoteSize(): Promise<number | undefined | null> {
        return new Promise((resolve) => {
            try {
                if (typeof this.env.navigator?.storage?.estimate === 'function') {
                    navigator?.storage
                        .estimate()
                        .then((estimate) => {
                            resolve(estimate?.quota);
                        })
                        .catch((err) => {
                            console.error(err);
                            resolve(null);
                        });
                } else {
                    resolve(null);
                }
            } catch (err) {
                console.error(err);
                resolve(null);
            }
        });
    }
}
